import { Component, OnInit, Output } from '@angular/core';
import { faCheck, faInfoCircle, faChevronCircleRight, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { EventEmitter } from '@angular/core';
import { isNullOrEmpty, isNullOrUndefined, isNullOrUndefinedObject } from 'src/app/helper/validation';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../helper/shared/shared.service';
import { ProjectService } from '../project.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { of } from 'rxjs';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { createPopper } from '@popperjs/core';

enum SaveStatus {
  Saving = 'Saving...',
  Saved = 'Saved.',
  Idle = '',
}

function sleep(ms: number): Promise<any> {
  return new Promise((res) => setTimeout(res, ms));
}

@Component({
  selector: 'app-customer-info',
  templateUrl: './customer-info.component.html',
  styleUrls: ['./customer-info.component.scss']
})
export class CustomerInfoComponent implements OnInit {
  @Output() nextStep = new EventEmitter<String>();
  faAngleRight = faAngleRight;
  faCheck = faCheck;
  faInfoCircle = faInfoCircle;
  faChevronCircleRight = faChevronCircleRight;
  flag = false;
  Info:boolean = false;
  showCustInfo:boolean = false;
  showTitleInfo:boolean = false;
  
  saveStatus: SaveStatus.Saving | SaveStatus.Saved | SaveStatus.Idle = SaveStatus.Idle;
  //projectId = this.projectService.projectdetails.projectInfo.id;
  customerInfo:any;
  customerinfo = this.projectService.getCustomerInfoEmptyValueStructure();

  constructor(
    private toastr: ToastrService,
    private projectService : ProjectService,
    public sharedService : SharedService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    window.scroll(0,0);
    this.projectService.activePage = 1;

    if (this.projectService.projectdetails.projectInfo != undefined) {
      this.customerinfo = this.projectService.projectdetails.customerInfo; 
    }
    // if(!isNullOrUndefinedObject(this.projectService.projectdetails.customerInfo)) {
    //   this.customerinfo = this.projectService.projectdetails.customerInfo;
    // //   //this.customerinfo = this.fromProjectDetails();
    // } else {
    //   this.projectService.projectdetails.customerInfo = this.customerinfo;
    // //   //this.projectService.projectdetails.customerInfo = this.toProjectDetails();
    // }
    window.onbeforeunload = () => this.ngOnDestroy();
  }

  fromProjectDetailsDEL() {
    //var tmpCustomerInfo = this.projectService.getCustomerInfoEmptyValueStructure();
    let tmpCustomerInfo = {
      city: this.projectService.projectdetails.customerInfo.city,
      contactnum: this.projectService.projectdetails.customerInfo.contactnum,
      contactperson: this.projectService.projectdetails.customerInfo.contactperson,
      country: this.projectService.projectdetails.customerInfo.country,
      customername: this.projectService.projectdetails.customerInfo.customername,
      email: this.projectService.projectdetails.customerInfo.email,
      state: this.projectService.projectdetails.customerInfo.state,
      street: this.projectService.projectdetails.customerInfo.street,
      title: this.projectService.projectdetails.customerInfo.title
    }
    return tmpCustomerInfo;
  }

  toProjectDetailsDEL() {
    let tmpCustInfoFromProjecDetails = {
      city: this.customerinfo.city,
      contactnum: this.customerinfo.contactnum,
      contactperson: this.customerinfo.contactperson,
      country: this.customerinfo.country,
      customername: this.customerinfo.customername,
      email: this.customerinfo.email,
      state: this.customerinfo.state,
      street: this.customerinfo.street,
      title: this.customerinfo.title
    }
    return tmpCustInfoFromProjecDetails;
  }

  Proceed() {
    this.flag = false;
    if (this.projectService.projectdetails.projectInfo != undefined) {
      if(isNullOrEmpty(this.customerinfo.customername)) {
        this.flag = true;
      }
    }
    if(this.flag && this.projectService.valid['customerInfo'] !== 'Skipped'){
      //Refresh from other pages then prevent this from showing before clicking on new project  this.toastr.warning('Please key-in Customer Name.', '');
    }
    else{
      //this.toProjectDetails();
      this.projectService.projectdetails['customerInfo'] = this.customerinfo;
      this.projectService.valid.customerInfo = 'Valid';
    }
  }

  next(){
    this.nextStep.emit();
  }

  ngOnDestroy() {
    if (this.projectService.valid['customerInfo'] === 'Skipped') {
      this.projectService.valid['customerInfo'] = '';
    }else {
      this.Proceed();
    }  
    this.sharedService.blnLoadFromRecord = false;  
  }

  onMouseClick(e: MouseEvent) {
    if (this.sharedService.clickOnMoreOptionsBtn) {
      var headerMenuClass: any;
      headerMenuClass = document.getElementsByClassName('topbar');
      for (var i=0; i< headerMenuClass.length; i++){
        if (headerMenuClass[i].style.zIndex == '-1') {
          headerMenuClass[i].style.zIndex = '99';
        } else {
          headerMenuClass[i].style.zIndex = '-1';
        }
      }
    }
  }

  showHideInfoToggle() {
    let CustomerInfo = document.getElementById('CustomerInfoBtn');
    let CustomerInfoToolTip = document.getElementById('CustomerInfo');
    this.createPop(CustomerInfo, CustomerInfoToolTip);
    if (this.customerInfo) {
      CustomerInfoToolTip.removeAttribute("data-show");
      this.customerInfo = false;
    } else {
      CustomerInfoToolTip.setAttribute("data-show", "");
      this.customerInfo = true;
    }
  }

  createPop(ref:any, popper:any ) {
    createPopper(ref, popper, {
      placement: 'top-start',
      modifiers: [
         {
           name: "offset",
           options: {
             offset: [0, 8],
           },
         },
      ],
    });
  }

  skipsection(){
    this.projectService.valid['customerInfo'] = 'Skipped';
    this.next();
  }

  detectChanges($event:any) {
    let inputname = $event.srcElement.name;
    let inputval = $event.srcElement.value;
    switch (inputname) {
      case "customername":
        this.customerinfo.customername = inputval;
        break;
      case "contactperson":
        this.customerinfo.contactperson = inputval;
        break;
      case "title":
        this.customerinfo.title = inputval;
        break;
      case "contactnum":
        this.customerinfo.contactnum = inputval;
        break;
      case "email":
        this.customerinfo.email = inputval;
        break;
      case "street":
        this.customerinfo.street = inputval;
        break;
      case "city":
        this.customerinfo.city = inputval;
        break;
      case "state":
        this.customerinfo.state = inputval;
        break;
      case "country":
        this.customerinfo.country = inputval;
        break;
    }
    this.projectService.projectdetails.customerInfo = this.customerinfo;
  }

}
